// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2d-UC","loaderOuter":"PageOverlayLoader_loaderOuter__CVK4T"};